import { Component, Input, OnInit } from '@angular/core';
import { encryptStorage } from 'src/app/auth/auth.service';
import { OrdersSearch } from 'src/app/models/orders';
import { DeliveryMethodValues, emptyFields } from 'src/app/utilities/common-file';
import { CommonService } from 'src/app/utilities/common-service';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { ViewReceiptsService } from 'src/app/view-receipts/view-receipts.service';
import { OrdersService } from '../../orders.service';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';

@Component({
  selector: 'app-generate-order-receipt',
  templateUrl: './generate-order-receipt.component.html',
  styleUrls: ['./generate-order-receipt.component.less']
})
export class GenerateOrderReceiptComponent implements OnInit {

  @Input() selectedOrders:any;
  loading=false;
  currencySymbol='';
  emptyField = emptyFields;
  deliveryMethods = DeliveryMethodValues;
  productDetails:any;
  addressDetails:any;
  value:any;
  total=0;
  private tableData: NzTableData<OrdersSearch, any> = new NzTableData<OrdersSearch, any>(new OrdersSearch(), 'fullName');
  constructor(private ordersService: OrdersService,
        private commonService: CommonService,private receiptService: ViewReceiptsService,private drawerRef: NzDrawerRef) { }

  ngOnInit() {
    this.currencySymbol = encryptStorage.getItem('currencySymbol');
    if(this.selectedOrders.deliveryMethod===this.deliveryMethods.doordelivery){
      this.addressDetails= this.selectedOrders.deliveryAddress ? JSON.parse(JSON.parse(this.selectedOrders.deliveryAddress)):'';
    }
    this.productDetails = this.selectedOrders.merchantOrderDetails.length>0 ? this.selectedOrders.merchantOrderDetails:'';
    this.refresh();
    this.findSumQuantity(this.productDetails);
  }
// For List
refresh(startFromPageOne: boolean = true): void {
  this.loading = true;
  this.tableData.data = [];
  if (startFromPageOne) {
    this.tableData.pageIndex = 1;
  }
  console.log(this.tableData);
  this.tableData.search.id=this.selectedOrders.id;
  this.ordersService.orderReceiptListWithLimit(this.tableData).subscribe((response: any) => {
     this.loading = false;
    this.tableData.total = response.data.total;
    
    if (response.data && response.data.merchantOrderReceipts) {
      this.tableData.data = response.data.merchantOrderReceipts;
    } else {
      this.tableData.data = [];
    }
  }, (err) => {
    this.loading = false;
    this.tableData.data = [];
  });
}
findSumQuantity(data){    
 this.value=data    
  console.log(this.value);  
 for(let j=0;j<data.length;j++){   
 this.total+= this.value[j].quantity  
       console.log(this.total)  
  }  
} 
getPaymentStatus(mode) {
  return this.commonService.getPaymentStatus(mode);
 }
 getSum(quantity,price){
  return quantity*price;
 }
 getDeliveryMethod(row){
  return this.commonService.getDeliveryMethod(row);
}
  // Download receipt as PDF
  getPdf() {
    this.receiptService.getPdfForGenerate(this.selectedOrders.id, 'receipt');
  }
  close() {
    this.drawerRef.close();
  }
}
